"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Modal_1 = require("@skbkontur/react-ui/components/Modal");

var react_ui_1 = require("@skbkontur/react-ui");

var Loader_module_css_1 = tslib_1.__importDefault(require("./Loader.module.css"));

var classnames_1 = tslib_1.__importDefault(require("classnames"));

var Parameters_1 = require("../Control/Parameters");

var configuration_1 = require("../../contexts/configuration");

var Loader =
/** @class */
function (_super) {
  tslib_1.__extends(Loader, _super);

  function Loader(props, context) {
    var _this = _super.call(this, props) || this;

    _this.showHandle = 0;
    _this.state = {
      show: !context.loaderShowDelay
    };
    return _this;
  }

  Loader.prototype.componentDidMount = function () {
    var _this = this;

    var loaderShowDelay = this.context.loaderShowDelay;

    if (!loaderShowDelay) {
      return;
    }

    this.showHandle = window.setTimeout(function () {
      _this.setState({
        show: true
      });
    }, loaderShowDelay);
  };

  Loader.prototype.componentWillUnmount = function () {
    clearTimeout(this.showHandle);
  };

  Loader.prototype.render = function () {
    var _a, _b;

    var caption = this.props.caption;
    var _c = this.context,
        view = _c.view,
        modalOptions = _c.modalOptions; // Задаем css классы для спиннера.

    var padClassName = classnames_1.default((_a = {}, _a[Loader_module_css_1.default.pad] = true, _a[Loader_module_css_1.default.modal] = view === Parameters_1.CertificatesListView.Modal, _a));
    var spinnerClassName = classnames_1.default((_b = {}, _b[Loader_module_css_1.default.spinner] = true, _b[Loader_module_css_1.default.show] = this.state.show, _b));
    var spinner = react_1.default.createElement("div", {
      "data-tid": "loader",
      className: padClassName
    }, react_1.default.createElement("div", {
      className: spinnerClassName
    }, react_1.default.createElement(react_ui_1.Spinner, {
      type: "normal",
      caption: ''
    }), react_1.default.createElement("div", {
      className: Loader_module_css_1.default.caption
    }, caption.split('\n').map(function (item, key) {
      return react_1.default.createElement("span", {
        key: key
      }, item, react_1.default.createElement("br", null));
    }))));

    if (modalOptions) {
      var width = modalOptions.width,
          onClose = modalOptions.onClose,
          ignoreBackgroundClick = modalOptions.ignoreBackgroundClick;
      return react_1.default.createElement(Modal_1.Modal, {
        "data-tid": "modal_loader",
        width: width,
        onClose: onClose,
        ignoreBackgroundClick: ignoreBackgroundClick
      }, react_1.default.createElement(Modal_1.Modal.Header, null, modalOptions.caption), react_1.default.createElement(Modal_1.Modal.Body, null, spinner));
    }

    return spinner;
  };

  Loader.contextType = configuration_1.configurationContext;
  return Loader;
}(react_1.default.Component);

exports.Loader = Loader;